<div class="mct-flex mct-col mct-gap-27">
  <div class="mct-flex mct-row mct-flex-lt-sm mct-col-lt-sm mct-justify-start mct-items-start mct-gap-27" style="padding-top: 15px">
    <div class="mct-flex mct-col atlas-autocomplete" style="flex: 1 1 0; min-width: 400px">
      <label>{{ 'revenue.ecommerce-transactions.revenue-items' | translate | titlecase }}</label>
      <p-autocomplete
        [suggestions]="revItemSearchResult"
        [(ngModel)]="selectedRevenueItems"
        [inputStyle]="{ width: '100%' }"
        (completeMethod)="searchRevenueItems($event)"
        [dataKey]="'ItemNum'"
        optionLabel="ItemName"
        [multiple]="true"
        [forceSelection]="true"
        (onSelect)="isDirty = true"
      >
      </p-autocomplete>
    </div>
    <div class="mct-flex mct-col" style="width: 180px; flex-shrink: 0">
      <label>{{ 'revenue.ecommerce-transactions.item-type' | translate | ucfirst }}</label>
      <p-select
        appendTo="body"
        name="itemNum"
        [(ngModel)]="searchParams.ItemTypeId"
        [placeholder]="'revenue.ecommerce-transactions.all-types' | translate | ucfirst"
        [style]="{ width: '100%' }"
        [options]="ecommerceTypes"
        showClear
        (onChange)="isDirty = true"
        required
      ></p-select>
    </div>
    <div class="mct-flex mct-col">
      <label>{{ 'revenue.ecommerce-transactions.order-date' | translate | titlecase }}</label>
      <wl-date-selector [(ngModel)]="searchParams.OrderDateRangeStart" (onDateChanged)="isDirty = true"></wl-date-selector>
    </div>
    <div class="mct-flex mct-col">
      <label>{{ 'common.to' | translate | titlecase }}</label>
      <wl-date-selector [(ngModel)]="searchParams.OrderDateRangeEnd" (onDateChanged)="isDirty = true"></wl-date-selector>
    </div>
    <div class="mct-flex mct-col mct-justify-end">
      <label style="visibility: hidden">{{ 'revenue.ecommerce-transactions.show-sent-items' | translate | titlecase }}</label>
      <div class="mct-flex mct-row mct-justify-center mct-items-start mct-gap-8">
        <p-checkbox binary="true" [(ngModel)]="searchParams.ShowSentItems" inputId="showSentItems" (onChange)="isDirty = true">
        </p-checkbox>
        <label for="showSentItems" style="padding-bottom: 0; cursor: pointer">
          {{ 'revenue.ecommerce-transactions.show-sent-items' | translate | titlecase }}
        </label>
      </div>
    </div>
    <div class="search-param-fill mct-flex mct-col mct-justify-end mct-items-stretch">
      <button pButton type="button" (click)="searchClicked()" class="atlas-btn atlas-btn-primary" type="button">
        {{ 'revenue.ecommerce-transactions.run-this-search' | translate | uppercase }}
      </button>
    </div>
  </div>
  <div class="mb-21">
    <a (click)="navigateToEcomSpa()">{{ 'revenue.ecommerce-transactions.view-store' | translate | titlecase }}</a>
    <hr />
    <div class="mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-justify-between mct-items-center">
      <div>
        <action-button
          styleClass="atlas-btn-primary"
          [disabled]="selectedCount == 0"
          [label]="'revenue.ecommerce-transactions.act-on-selected-transactions' | translate: { selectCount: selectedCount } | uppercase"
          [items]="actionsOptions"
        >
        </action-button>
      </div>
      <div class="mct-flex mct-row mct-justify-between mct-items-center">
        <div style="margin-right: 10px; display: inline">
          {{ 'profiles.search.search-returned' | translate | ucfirst }}
          <span style="font-weight: bold"
            >{{ searchResult?.TotalCount ?? 0 }}&nbsp;{{ 'ecommerce.transactions.transactions' | translate }}</span
          >
        </div>
        <div>
          <wl-busy *ngIf="exporting" [show]="exporting"></wl-busy>
          <button pButton type="button" (click)="exportClicked()" class="atlas-btn atlas-btn-primary" type="button" [disabled]="exporting">
            {{ 'revenue.ecommerce-transactions.export-all-results' | translate | uppercase }}
          </button>
        </div>
        <div>
          <button
            pButton
            type="button"
            class="atlas-btn atlas-btn-secondary ml-10"
            icon="pi pi-times"
            [label]="'profiles.search.clear' | translate | uppercase"
            [disabled]="!isDirty"
            (click)="clearSearch()"
          ></button>
        </div>
      </div>
    </div>
    <hr />
  </div>
  <div>
    <p-table
      [showGridlines]="true"
      [value]="searchResult?.Result"
      [lazy]="true"
      [paginator]="true"
      [rows]="searchParams ? searchParams.PageSize : 20"
      [lazy]="true"
      [totalRecords]="searchResult?.TotalCount"
      (onLazyLoad)="lazyLoad($event)"
    >
      <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
        <SortAltIcon *ngIf="sortOrder === 0">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
        </SortAltIcon>
        <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
        </SortAmountUpAltIcon>
        <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
        </SortAmountDownIcon>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th>
            <p-checkbox binary="true" [(ngModel)]="selectAll" (onChange)="onSelectAllChange()"></p-checkbox>
          </th>
          <th pSortableColumn="DateCreated">
            {{ 'revenue.ecommerce-transactions.order-date' | translate | ucfirst }}
            <p-sortIcon field="DateCreated"></p-sortIcon>
          </th>
          <th pSortableColumn="ECommerceItem.Title">
            {{ 'revenue.ecommerce-transactions.item-name' | translate | ucfirst }}
            <p-sortIcon field="ECommerceItem.Title"></p-sortIcon>
          </th>
          <th pSortableColumn="Amount">
            {{ 'common.revenue.amount' | translate | ucfirst }}
            <p-sortIcon field="Amount"></p-sortIcon>
          </th>
          <th pSortableColumn="InvoiceNum">
            {{ 'revenue.ecommerce-transactions.invoice-num' | translate | ucfirst }}
            <p-sortIcon field="InvoiceNum"></p-sortIcon>
          </th>
          <th pSortableColumn="ItemNumNavigation.ItemName">
            {{ 'revenue.ecommerce-transactions.revenue-item-name' | translate | ucfirst }}
            <p-sortIcon field="ItemNumNavigation.ItemName"></p-sortIcon>
          </th>
          <th pSortableColumn="InvoiceNumNavigation.ProfileReportName">
            {{ 'revenue.ecommerce-transactions.profile-name' | translate | ucfirst }}
            <p-sortIcon field="InvoiceNumNavigation.ProfileReportName"></p-sortIcon>
          </th>
          <th pSortableColumn="InvoiceNumNavigation.DateSent">
            {{ 'revenue.ecommerce-transactions.sent' | translate | ucfirst }}
            <p-sortIcon field="InvoiceNumNavigation.DateSent"></p-sortIcon>
          </th>
          <th></th>
          <th [style]="{ width: '120px' }"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-transaction>
        <tr>
          <td>
            <p-checkbox
              binary="true"
              [ngModel]="itemIsSelected(transaction)"
              (ngModelChange)="onRowSelectionChange(transaction)"
            ></p-checkbox>
          </td>
          <td>
            {{ transaction.DateOrdered | date }}
          </td>
          <td>
            {{ transaction.EcomItemName }}
          </td>
          <td>
            {{ transaction.Amount | translate | atlasCurrency }}
          </td>
          <td>
            <a (click)="editInvoice(transaction.InvoiceNum)">{{ transaction.InvoiceNum }}</a>
          </td>
          <td>
            {{ transaction.RevItemName }}
          </td>
          <td>
            <wl-profile-type-icon
              *ngIf="transaction.ProfileId"
              [isMember]="transaction.ProfileMember"
              [isOrg]="transaction.ProfileOrgInd"
              [profileId]="transaction.ProfileId"
              [profileId]="transaction.ProfileMemberIconColor"
            ></wl-profile-type-icon>
            {{ transaction.ProfileReportName }}
          </td>
          <td>
            <wl-date-selector [(ngModel)]="transaction.DateSent" (onDateChanged)="dateSentChanged(transaction)"></wl-date-selector>
          </td>
          <td>
            <p-checkbox [(ngModel)]="transaction.Sent" binary="true" (onChange)="sentChanged(transaction)"></p-checkbox>
          </td>
          <td>
            <div>
              <action-button icon="pi pi-chevron-down" [label]="'common.actions' | translate | uppercase" [items]="rowActions(transaction)">
              </action-button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <p-progressSpinner *ngIf="loading"></p-progressSpinner>
    <wl-page-size-dropdown
      [(pageSize)]="searchParams.PageSize"
      [pageSizes]="[20, 100, 0]"
      (pageSizeChange)="pageSizeChanged()"
    ></wl-page-size-dropdown>
  </div>
</div>
